export default __webpack_public_path__ + "static/media/openfile.425b5b39.svg";